// Généré par connecteur/create-perso-product.js — NE PAS ÉDITER À LA MAIN.
// Variantes du produit « Personnalisation de vos produits » : facturation de la
// personnalisation atelier au checkout. Zones × paliers alignés sur P.TIERS_V.
window.REVDECO_PERSO = {
  "handle": "personnalisation-atelier",
  "byZone": {
    "large": [
      {
        "id": 55418389496137,
        "price": 990
      },
      {
        "id": 55418389528905,
        "price": 490
      },
      {
        "id": 55418389561673,
        "price": 245
      },
      {
        "id": 55418389594441,
        "price": 155
      },
      {
        "id": 55418389627209,
        "price": 135
      },
      {
        "id": 55418389659977,
        "price": 130
      }
    ],
    "small": [
      {
        "id": 55418389692745,
        "price": 650
      },
      {
        "id": 55418389725513,
        "price": 180
      },
      {
        "id": 55418389758281,
        "price": 120
      },
      {
        "id": 55418389791049,
        "price": 85
      },
      {
        "id": 55418389823817,
        "price": 75
      },
      {
        "id": 55418389856585,
        "price": 65
      }
    ],
    "sleeve": [
      {
        "id": 55418389889353,
        "price": 750
      },
      {
        "id": 55418389922121,
        "price": 250
      },
      {
        "id": 55418389954889,
        "price": 180
      },
      {
        "id": 55418389987657,
        "price": 140
      },
      {
        "id": 55418390020425,
        "price": 125
      },
      {
        "id": 55418390053193,
        "price": 110
      }
    ],
    "bro_large": [
      {
        "id": 55470474723657,
        "price": 2490
      },
      {
        "id": 55470474756425,
        "price": 1890
      },
      {
        "id": 55470474789193,
        "price": 1490
      },
      {
        "id": 55470474821961,
        "price": 1290
      },
      {
        "id": 55470474854729,
        "price": 1190
      },
      {
        "id": 55470474887497,
        "price": 1090
      }
    ],
    "bro_small": [
      {
        "id": 55470474920265,
        "price": 1290
      },
      {
        "id": 55470474953033,
        "price": 990
      },
      {
        "id": 55470474985801,
        "price": 790
      },
      {
        "id": 55470475018569,
        "price": 690
      },
      {
        "id": 55470475051337,
        "price": 640
      },
      {
        "id": 55470475084105,
        "price": 590
      }
    ]
  },
  "broSetup": {
    "id": 55470475116873,
    "price": 4000
  }
};
